import { render, staticRenderFns } from "./ToneOfVoiceSelectorButton.vue?vue&type=template&id=1ebab3c4&"
import script from "./ToneOfVoiceSelectorButton.vue?vue&type=script&lang=js&"
export * from "./ToneOfVoiceSelectorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports